import { render, staticRenderFns } from "./a-text-multi-line.vue?vue&type=template&id=05d5b529&"
import script from "./a-text-multi-line.vue?vue&type=script&lang=js&"
export * from "./a-text-multi-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports